<script lang="ts">
  import { convertStatamicAssetToCDN } from "@utils/cdn";

  export let image: Statamic.AssetsField;
</script>

{#if image}
  <picture>
    <source
      media="(max-aspect-ratio:1/2 )"
      srcset={convertStatamicAssetToCDN(image.id, {
        aspect_ratio: "2:4",
        quality: 80,
      })}
      type="image/webp"
    />
    <source
      media="(max-aspect-ratio:1/1 )"
      srcset={convertStatamicAssetToCDN(image.id, {
        aspect_ratio: "1:1",
        quality: 80,
      })}
      type="image/webp"
    />
    <source
      media="(max-aspect-ratio:4/3 )"
      srcset={convertStatamicAssetToCDN(image.id, {
        aspect_ratio: "4:3",
        quality: 90,
      })}
      type="image/webp"
    />
    <source
      media="(max-aspect-ratio:16/9)"
      srcset={convertStatamicAssetToCDN(image.id, {
        aspect_ratio: "16:9",
        quality: 90,
      })}
      type="image/webp"
    />
    <source
      media="(min-width: 1200px)"
      srcset={convertStatamicAssetToCDN(image.id, {
        quality: 100,
        width: 2400,
      })}
      type="image/webp"
    />
    <img
      src={convertStatamicAssetToCDN(image.id, { quality: 100 })}
      alt={image.alt}
      {...$$restProps}
    />
  </picture>
{/if}
